<template>
  <div>
    <main class="flex-1 relative pb-8 z-0">
      <div class="bg-white shadow">
        <div class="px-4 sm:px-6 lg:mx-auto lg:px-8 max-w-7xl">
          <div class="pb-6 pt-6 md:flex md:items-center md:justify-between lg:border-t lg:border-cool-gray-200">
            <div class="text-3xl font-bold leading-7 text-cool-gray-900 sm:leading-9 sm:truncate">
              Events
            </div>

            <div class="flex items-center">
              <PrimaryButton
                text="New event"
                icon="fal fa-plus"
              />
              <div class="w-72 ml-2">
                <Dropdown
                  :list="courses"
                  :default-item="courses[0]"
                />
              </div>
            </div>
          </div>

          <div class="pb-4">
            <div class="flex items-center">
              <Tabs
                :tabs="tabs"
                :selected-tab="selectedTab"
              />

              <div
                class="cursor-pointer ml-2 text-gray-500 hover:text-gray-700 transition-all duration-500"
                @click="showDatePicker = !showDatePicker"
              >
                <i class="far fa-chevron-down" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <DatePicker
      v-if="showDatePicker"
      :date="selectedDate"
      class="relative z-20"
      @dateChanged="dateChanged"
    />

    <div
      v-if="showDatePicker"
      class="z-10 fixed top-0 left-0 w-full min-w-full h-full min-h-full"
      @click="showDatePicker = false"
    />
  </div>
</template>

<script>
import Tabs from '@/app/shared/components/navigation/tabs/tabs.vue';
import Dropdown from '@/app/shared/components/form/dropdown/dropdown.vue';
import DatePicker from '@/app/shared/components/date/datePicker.vue';
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';

export default {
  name: 'Home',

  components: {
    Tabs,
    Dropdown,
    DatePicker,
    PrimaryButton,
  },

  data() {
    return {
      selectedDate: new Date(),
      currentDate: new Date(),
      showDatePicker: false,

      tabs: ['Today', 'Mon 16th', 'Tue 17th', 'Wed 18th', 'Thu 19th'],
      courses: [
        { primaryText: 'Championship Course', secondaryText: '18 Holes' },
        { primaryText: 'Dismal Bay', secondaryText: '9 Holes' },
        { primaryText: 'Wooden Spoon Course', secondaryText: '9 Holes' },
      ],
      selectedTab: 'Today',

      dayIndex: 0,
    };
  },

  computed: {


  },

  watch: {

  },

  mounted() {
  },

  methods: {

  },

};
</script>
